import { COURSE_MODULE_VERSION } from '../../config-global';

// Динамический импорт версий модуля
const loadVersion = () => {
    if (COURSE_MODULE_VERSION === 'v2') {
        // V2 - полная версия с mock API (для референса и разработки)
        return {
            courseReducer: require('./v2/redux/slice').default,
            courseRoutes: require('./v2/routes').courseRoutes,
        };
    }
    // V1 - упрощенная версия с реальным API (по умолчанию)
    return {
        courseReducer: require('./v1/redux/slice').default,
        courseRoutes: require('./v1/routes').courseRoutesV1,
    };
};

const { courseReducer, courseRoutes } = loadVersion();

export { courseReducer, courseRoutes };

